import { HTTPResponse } from "../../../../common/types/commonTypes";
import { toasterNotification } from "../../../../common/utils/ToasterNotification";
import { api } from "../../../../app/baseQuery";

import {
  AirlineDataType,
  IAirlineEditFormData,
  IAirlineFormData,
} from "../types/AirlinesTypes";
import assyncWrapper from "../../../../common/utils/assyncWrapper";
import { message } from "antd";

const AIRLINE = "AIRLINE";
export const airlineEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    // get all airlines
    getAllAirlines: build.query<HTTPResponse<AirlineDataType[]>, void>({
      query: () => ({ url: `/configuration/airlines/read` }),
      providesTags: () => [{ type: "Airline", id: AIRLINE }],
    }),

    // get all airlines
    getAllAirlinesWithPagination: build.query<
      HTTPResponse<AirlineDataType[]>,
      { current: number; pageSize: number }
    >({
      query: (arg) => ({
        url: `/configuration/airlines?page=${arg.current}&size=${arg.pageSize}`,
      }),
      providesTags: () => [{ type: "Airline", id: AIRLINE }],
    }),

    // create airline
    createAirline: build.mutation<void, IAirlineFormData>({
      query: (body) => ({
        url: `/configuration/airlines/create`,
        method: "POST",
        body: body,
      }),
      onQueryStarted: async (_arg, { queryFulfilled }) => {
        assyncWrapper(async () => {
          await queryFulfilled;
          message.success("Airline Added Successfully");
        });
      },

      invalidatesTags: () => [{ type: "Airline", id: AIRLINE }],
    }),

    //edit airline
    editAirline: build.mutation<
      void,
      { body: IAirlineEditFormData; id: number }
    >({
      query: ({ body, id }) => ({
        url: `/configuration/airlines/update/${id}`,
        method: "PATCH",
        body: body,
      }),
      onQueryStarted: async (_arg, { queryFulfilled }) => {
        assyncWrapper(async () => {
          await queryFulfilled;
          message.success("Airline Edited Successfully");
        });
      },

      invalidatesTags: () => [{ type: "Airline", id: AIRLINE }],
    }),

    //delete airline
    deleteAirline: build.mutation<void, AirlineDataType>({
      query: (body) => ({
        url: `/configuration/airlines/delete/${body.airline_id}`,
        method: "DELETE",
        body: body,
      }),

      invalidatesTags: () => [{ type: "Airline", id: AIRLINE }],
    }),
  }),
});

export const {
  useGetAllAirlinesQuery,
  useCreateAirlineMutation,
  useEditAirlineMutation,
  useDeleteAirlineMutation,
  useGetAllAirlinesWithPaginationQuery,
} = airlineEndpoints;
